#import "./downtimeBlock/downtimeBlockInfo.gql"
#import "./shiftInstance/shiftInstanceInfo.gql"
#import "./workBlock/workBlockInfo.gql"

query GetSchedulerData($startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  shiftInstances(scheduledStart: $startDate, scheduledEnd: $endDate) @connection(key: "shiftInstances") {
    ...shiftInstanceInfo
  }
  blocks(startsAt: $startDate, endsAt: $endDate) @connection(key: "blocks") {
    workBlocks {
      ...workBlockInfo
    }
    downtimeBlocks {
      ...downtimeBlockInfo
    }
  }
  unavailabilities(scheduleStart: $startDate, scheduleEnd: $endDate) @connection(key: "unavailabilities") {
    startsAt
    endsAt
    line {
      id
      name
    }
    shift {
      id
      name
    }
  }
}
